import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CopyButton',
  props: {
    copyText: {},
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const isShowTooltip = ref(false);
const prevTimeoutId = ref<ReturnType<typeof setTimeout>>(0 as any);

const buttonName = computed(() => {
  return isShowTooltip.value ? 'コピーしました' : '内容をコピー'
})

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
  showTooltip()
}

const showTooltip = () => {
  isShowTooltip.value = true
  emits('update:modelValue', true)
  clearTimeout(prevTimeoutId.value)
  prevTimeoutId.value = setTimeout(() => {
    isShowTooltip.value = false
  }, 2000)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    color: "#1976D2",
    style: {"color":"white"},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(props.copyText)))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(buttonName.value), 1)
    ]),
    _: 1
  }))
}
}

})